"use client"

import AddCompanyModal from "@/components/AddCompanyModal";
import CompaniesTable from "@/components/CompaniesTable";
import { CompanySchema } from "@/schemas/company.schema";
import { getCompanies } from "@/services/companies.service";
import { useEffect, useState } from "react";
import { z } from "zod";

export default function CompaniesPage() {
    const [companies, setCompanies] = useState<z.infer<typeof CompanySchema>[]>([]);

    const loadAllCompanies = async () => {
        const companies = await getCompanies();
        setCompanies(companies);
    }

    useEffect(() => {
        loadAllCompanies();
    }, [])


    return (
        <div className="flex flex-col gap-6 dark:bg-black dark:text-white">
            <div>
                <AddCompanyModal onAddSuccess={loadAllCompanies} />
            </div>
            <CompaniesTable companies={companies} />
        </div>
    )
}